const initialState=localStorage.getItem("token");

const token = (state=initialState,actions)=>{
    switch (actions.type){
        case "SET_TOKEN" : return actions.payload;
        case "CLEAR_TOKEN": return "";
        default : return state;
    }
}
export default token;